import React from 'react';
import { ArrowUpRightIcon, FileSpreadsheetIcon, FileTextIcon, FolderIcon, GlobeIcon, PresentationIcon } from 'lucide-react';
import type { DocumentKind, ProjectDocument } from '../types/project';
const KIND_META: Record<DocumentKind, {
  label: string;
  Icon: React.ComponentType<{
    className?: string;
  }>;
}> = {
  deck: {
    label: 'Deck',
    Icon: PresentationIcon
  },
  sheet: {
    label: 'Sheet',
    Icon: FileSpreadsheetIcon
  },
  doc: {
    label: 'Doc',
    Icon: FileTextIcon
  },
  pdf: {
    label: 'PDF',
    Icon: FileTextIcon
  },
  folder: {
    label: 'Folder',
    Icon: FolderIcon
  },
  link: {
    label: 'Link',
    Icon: GlobeIcon
  }
};
interface DocumentRowProps {
  document: ProjectDocument;
}
export function DocumentRow({
  document
}: DocumentRowProps) {
  const {
    label,
    Icon
  } = KIND_META[document.kind];
  return <li data-id="element-46" data-mp="2baw4woz1w7ux">
      <a href={document.url} target="_blank" rel="noreferrer noopener" className="group flex items-center gap-4 px-5 py-4 transition hover:bg-[var(--b-surface-alt)] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--b-accent)]" data-id="element-47" data-mp="2ba4l0betfykh">
        <span style={{
        borderRadius: 'var(--b-radius)',
        backgroundColor: 'var(--b-tint)'
      }} className="flex h-9 w-9 shrink-0 items-center justify-center border border-[var(--b-border)]" data-id="element-48" data-mp="3n82n8wqsx4nq">
          <Icon className="h-4 w-4 text-[var(--b-accent)]" aria-hidden="true" data-id="element-49" data-mp="qv0wan8kt4" />
        </span>

        <span className="min-w-0 flex-1" data-id="element-50" data-mp="epeql2khouj2">
          <span className="block truncate text-sm font-medium text-[var(--b-text)]" data-id="element-51" data-mp="9s515mx3oiv8">
            {document.name}
          </span>
          <span className="mt-0.5 block font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--b-dim)]" data-id="element-52" data-mp="nql9fiam2hfh">
            {label} · {document.owner} · {document.updated}
          </span>
        </span>

        <ArrowUpRightIcon className="h-4 w-4 shrink-0 text-[var(--b-dim)] transition group-hover:text-[var(--b-accent)]" aria-hidden="true" data-id="element-53" data-mp="2pk2fihj3fa84" />
      </a>
    </li>;
}